import { Fragment } from 'react'
import { flowRight as compose } from 'lodash'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'
import withTermsNPrivacyLayout from '@/components/Layout/TermsAndPrivacy'

import { PRIVACY_POLICY } from '@/features/term-privacy/constants'
import { renderTemplate } from '@/features/term-privacy/utils'

function Privacy() {
  return (
    <Fragment>
      <NextSeo title="นโยบายความเป็นส่วนตัว" />

      <h1>นโยบายความเป็นส่วนตัว</h1>
      <p>
        นโยบายความเป็นส่วนตัวฉบับนี้ (“นโยบาย”) อธิบายถึงวิธีการที่ PDPA Pro
        (“บริษัท เอ็นเดต้าธอธ จำกัด”หรือ“เรา”) เก็บรวบรวม ใช้ และเปิดเผย
        ข้อมูลส่วนบุคคล (“ข้อมูลส่วนบุคคล”) ที่ท่าน (“ผู้ใช้” หรือ “ท่าน”)
        ได้ให้สำหรับการใช้งานเว็บไซต์ PDPA Pro และผลิตภัณฑ์หรือบริการดังกล่าว
        (เรียกรวมกันว่า “เว็บไซต์” หรือ “บริการ”)
        เพื่อให้สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
        (“PDPA”)
      </p>
      <p>
        ซึ่งรวมไปถึงการอธิบายในตัวเลือกสำหรับท่านเกี่ยวข้องกับการใช้ข้อมูลส่วนบุคคลของท่านและวิธีการให้ท่านเข้าถึงข้อมูลหรือทำให้ข้อมูลเป็นปัจจุบัน
        นโยบายฉบับนี้ไม่บังคับใช้กับการปฏิบัติงานของบริษัทที่เราไม่ได้เป็นผู้ดูแลหรือบุคคลที่เราไม่ได้มีการจ้างหรือต้องจัดการ
      </p>

      {renderTemplate(PRIVACY_POLICY.subMenus)}

      <div id="endTermsContent" css={{ marginTop: 48 }}>
        นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ 29 สิงหาคม พ.ศ. 2565
      </div>
    </Fragment>
  )
}

export default compose(withPage(), withTermsNPrivacyLayout)(Privacy)
